export const defaultTemplateBody = `
  <p> Hi [Full Name],</p>
  <br>
  <p> I hope this email finds you well.
  
  At [Organization Name], we greatly value your opinion and are constantly striving to enhance your experience. To achieve this, we invite you to provide your inputs by clicking the link below.
  
  Form Link: [Form Link]
  
  Rest assured, your responses will remain confidential, and your personal information will be handled with the utmost care. We appreciate your candid feedback and look forward to hearing your thoughts.
  
  Thank you for being a valued member of the [Organization Name] community.
  </p>
  <br>
  <p>
  Best regards,
  [Organization Name]
  </p>
`;
